import { getterTypesOrdersReworkProperties } from '@/store/modules/orders-rework-properties/types'

export default {
    [getterTypesOrdersReworkProperties.getProperties]: (state) => {
        return state.ordersReworkProperties
    },
}
